<template>
  <div class="white-container equity-page">
    <el-tabs v-model="activeName" :before-leave="beforeLeave" class="equity-tabs">
      <el-tab-pane label="新品优先权" name="one" />
      <el-tab-pane label="限量包装券" name="two" />
      <el-tab-pane label="免费洗鞋券" name="three" />
      <el-tab-pane label="运动体验券" name="four">
        <el-form ref="form" class="my-form" :model="form" :rules="rules" label-width="120px" size="small">
          <el-form-item label="权益主标题" prop="titles">
            <div v-if="isEdit" class="mainTitleWrap flex">
              <template v-for="(mainTitle,titleN) in form.titles">
                <el-input :key="titleN+'mainTitle'" v-model="form.titles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行主标题文案' : '请输入第二行主标题文案' " />
              </template>
            </div>
            <div v-else class="lh-20" style="padding-top: 5px;">
              <div v-for="(mainTitle,titleN) in form.titles" :key="titleN+'mainTitle'">{{ mainTitle }}</div>
            </div>

          </el-form-item>
          <el-form-item label="副标题" prop="subtitles">
            <div v-if="isEdit" class="subTitleWrap flex">
              <template v-for="(subTitle,titleN) in form.subtitles">
                <el-input :key="titleN+'subTitle'" v-model="form.subtitles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行副标题文案' : '请输入第二行副标题文案'" />
              </template>
            </div>
            <div v-else class="lh-20" style="padding-top: 5px;">
              <div v-for="(subTitle,titleN) in form.subtitles" :key="titleN+'subTitle'">{{ subTitle }}</div>
            </div>
          </el-form-item>
          <el-form-item label="领取时间" prop="weekStart">
            <div v-if="isEdit" class="flex">
              <div class="flex" style="flex-wrap: nowrap;">
                <div style="white-space: nowrap; margin-right: 5px;">每天</div>
                <div class="flex">
                  <!-- <el-select v-model="form.weekStart" style="width: 72px;" placeholder="开始">
                    <el-option v-for="item in weekList" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select> -->
                  <el-time-picker v-model="form.startHour" style="width: 94px" format="HH:mm" value-format="HH:mm" placeholder="时间" />
                  <div style="color:#494949; margin: 0 6px;">-</div>
                  <!-- <el-select v-model="form.weekEnd" style="width: 72px;" placeholder="结束">
                    <el-option v-for="item in weekList" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select> -->
                  <el-time-picker v-model="form.endHour" style="width: 94px" format="HH:mm" value-format="HH:mm" placeholder="时间" />
                  <div style="color:#494949; margin: 0 6px;">领取</div>
                </div>
              </div>
              <!-- <div class="flex tips">
                <span style="white-space: nowrap;">提前</span>
                <el-input v-model="form.advanceBookingDays" type="number" :min="0" class="day-input" oninput="value=value.replace('/^[1-9]\d*$/','');if(value<=0)value=0" />
                <span style="white-space: nowrap;">天展示卡片进行预热</span>
              </div> -->
            </div>
            <div v-else class="flex" style="align-items: center;">
              <!-- <i class="el-icon-date" style="font-size: 24px; margin-right: 10px;" /> -->
              <span style="margin-right: 6px;">每天</span>
              <span>{{ $moment(form.startHour, "HH:mm:ss").format('HH:mm') }}</span>
              <span style="margin-left: 3px; margin-right: 3px;">-</span>
              <span> {{ $moment(form.endHour, "HH:mm:ss").format('HH:mm') }}</span>
              <span style="margin-left: 3px; margin-right: 3px;">领取</span>
              <!-- <span style="margin-left: 20px;">提前</span>
              <span style="padding: 0 20px;">{{ form.advanceBookingDays }}</span>
              <span>天展示卡片进行预热</span> -->
            </div>
          </el-form-item>
          <el-form-item label="背景图" prop="imageUrl" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage v-if="isEdit" :url="form.imageUrl" size-tips="960px*660px" :save-path="savePath" @upload="uploader" @triggerReg="handleCheckReg" />
              <img v-else class="read-img" :src="form.imageUrl" alt="">
            </div>
          </el-form-item>
          <el-form-item class="opetare-box flex">
            <div class="flex btns">
              <template v-if="isEdit">
                <el-button type="info" @click="cancel">取消</el-button>
                <el-button type="primary" @click="submit">保存</el-button>
              </template>
              <template v-else>
                <el-button type="info" @click="edit">编辑权益</el-button>
                <el-button type="primary" @click="offShelf">下架此项权益</el-button>
              </template>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="活动专属优惠" name="five" />
      <el-tab-pane label="促销优先权" name="six" />
      <el-tab-pane label="品牌活动邀请" name="seven" />
      <el-tab-pane label="周年纪念礼" name="eight" />
    </el-tabs>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { BenefitsRoutes, SportsExperienceVoucher } from '@/model/Benefits';
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      savePath: "member/sportsExperienceVoucher/",
      BenefitsRoutes,
      activeName: 'four',
      form: new SportsExperienceVoucher(),
      id: undefined,
      weekList: [
        {
          id: 1,
          name: "周1",
        },
        {
          id: 2,
          name: "周2",
        },
        {
          id: 3,
          name: "周3",
        },
        {
          id: 4,
          name: "周4",
        },
        {
          id: 5,
          name: "周5",
        },
        {
          id: 6,
          name: "周6",
        },
        {
          id: 7,
          name: "周7",
        },
      ],
      rules: {
        titles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入权益主标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入权益主标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        subtitles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入副标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入副标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        weekStart: [
          {
            required: true, validator: (rule, value, callback) => {
              const { startHour, endHour } = this.form;
              if (!startHour) {
                callback(new Error('请选择开始时间'));
              }
              if (!endHour) {
                callback(new Error('请选择结束时间'));
              }
              /* if (weekEnd < weekStart || this.$moment(startHour).isAfter(endHour)) {
                callback(new Error('结束时间不能早于开始时间'));
              } */
              const now = this.$moment().format('YYYY-MM-DD') + ' ';
              console.log('startHour', startHour);
              console.log('endHour', endHour);
              if (this.$moment(now + startHour).isAfter(now + endHour)) {
                callback(new Error('结束时间不能早于开始时间'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        imageUrl: [
          { required: true, message: '请上传背景图', trigger: 'blur' },
        ],
        productName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        productDescription: [
          { required: true, message: '请输入商品介绍', trigger: 'blur' },
        ],
        productImages: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!value.length) {
                callback(new Error('请上传商品图片'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
      },
      isEdit: true,
      formDialogShow: false,
      information: {},
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    beforeLeave(activeName, oldActiveName) {
      this.$router.push({ path: this.BenefitsRoutes[activeName] || this.BenefitsRoutes['one'] });
    },
    fetchData() {
      this.$Api.benefits.query({ type: 10 }).then(res => {
        if (res?.sportsExperience) {
          this.form = new SportsExperienceVoucher(res.sportsExperience);
          if (this.form.id) {
            this.isEdit = false;
          }
          if (res.sportsExperience?.adminStatus === 2 || res.sportsExperience?.adminStatus === 8) {
            this.isEdit = true;
          }
        }
      });
    },
    uploader(file) {
      this.form.imageUrl = file;
    },
    handleCheckReg() {
      this.$refs.form.validateField("imageUrl");
    },
    cancel() {
      this.isEdit = false;
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const str = this.form.id ? '编辑成功' : '新增成功';
          const api = this.form.id ? this.$Api.benefits.update : this.$Api.benefits.add;
          const obj = { type: 10, sportsExperienceCoupon: this.form };
          delete obj.sportsExperienceCoupon.adminStatus;
          const now = this.$moment().format('YYYY-MM-DD') + ' ';
          obj.sportsExperienceCoupon.startHour = this.$moment(now + obj.sportsExperienceCoupon.startHour).format('HH:mm') + ':00';
          obj.sportsExperienceCoupon.endHour = this.$moment(now + obj.sportsExperienceCoupon.endHour).format('HH:mm') + ':59';
          api(obj).then(res => {
            this.$message.success(str);
            this.fetchData();
            this.cancel();
          });
        }
      });
    },
    edit() {
      if (this.form.adminStatus === 0 || this.form.adminStatus === 1 || this.form.adminStatus === 7) {
        this.formDialogShow = true;
        this.information = {
          operation: 'edit',
          icon: 'warn',
          subTitle: '权益已对外发布，领取期间内不能编辑，如有紧急问题，请使用下架此项权益',
          hideCancel: true,
        };
        return;
      }
      this.isEdit = true;
    },
    offShelf() {
      this.formDialogShow = true;
      this.information = {
        operation: 'offShelf',
        icon: 'warn',
        subTitle: '如已对外发布，请谨慎操作，确定下架此项权益吗？',
      };
    },
    postOffline() {
      this.$Api.benefits.offShelf({ type: 2, id: this.form.id }).then(res => {
        this.$message.success('下架成功');
        this.fetchData();
      });
    },
    dialogSuccess(operation) {
      if (operation === 'offShelf') {
        this.postOffline();
      }
    },
  },
};

</script>
<style lang="less" scoped>
.equity-page {
  position: relative;

  display: flex;
  flex-direction: column;

  min-height: calc(100vh - 178px);
  .lh-20 {
    line-height: 20px;
  }
  .common-input {
    width: 360px;
    margin-right: 30px;
  }
  :deep(.equity-tabs) {
    display: flex;
    flex: 1;
    flex-direction: column;

    height: 100%;
    .el-tabs__header {
      margin: 0 0 30px;
    }
    .el-tabs__content {
      display: flex;
      overflow-x: unset !important;
      flex: 1;
      flex-direction: column;
      .el-tab-pane {
        display: flex;
        flex: 1;
        flex-direction: column;
        .my-form {
          display: flex;
          flex: 1;
          flex-direction: column;
        }
      }
    }
    .day-input {
      width: 86px;
      margin: 0px 5px;
      .el-input__inner {
        text-align: center;
      }
    }
    .tips {
      flex-wrap: nowrap;

      margin-left: 5px;
    }
    .read-img {
      width: 210px;
      height: 150px;

      border-radius: 16px;
    }
    .opetare-box {
      margin-top: auto;
      .el-form-item__content {
        width: 100%;
        .btns {
          justify-content: center;
        }
      }
    }
  }
}
</style>
